import { useState } from 'react';
import { NavLink } from 'react-router-dom';

import { TableRow, Tooltip, Typography, IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import { TableBodyCell } from '../table-cells/TableCells';
import RemoveCollection from './RemoveCollection';
import Icon from '../Icon';

import {
  useGetAuthenticationQuery,
  useGetProfilesQuery,
} from '../../services/ADapi';

import './Collections.scss';

const CollectionsListItem = ({
  id,
  priority,
  name,
  profile,
  users,
  dataposition,
  onDragStart,
  onDragOver,
  onDrop,
  onDragLeave,
  onChangePriority,
}) => {
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const { data: profileById = {} } = useGetProfilesQuery(user_id, {
    selectFromResult: ({ data }) => ({
      data: data?.find((currentProfile) => currentProfile.id === profile),
    }),
  });

  const [isDialogShow, setDialogState] = useState(false);

  const dialogStateHandler = () => {
    setDialogState((prevState) => !prevState);
  };

  return (
    <>
      <TableRow
        key={id}
        draggable
        data-position={dataposition}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragLeave={onDragLeave}
        onDragEnd={onChangePriority}
      >
        <TableBodyCell scope="row">
          <Tooltip
            arrow
            placement="right"
            title={
              <Typography>
                Hold down the icon and move the line to change the priority of
                the Collection
              </Typography>
            }
          >
            <DragIndicatorIcon className="drag-icon" />
          </Tooltip>
        </TableBodyCell>
        <TableBodyCell align="center">{priority}</TableBodyCell>
        <TableBodyCell align="left">{name}</TableBodyCell>
        <TableBodyCell align="left">{profileById.name}</TableBodyCell>
        <TableBodyCell align="left">{users}</TableBodyCell>
        <TableBodyCell sx={{ width: '72px' }}>
          <NavLink to={id.toString()}>
            <IconButton>
              <Icon id="edit" />
            </IconButton>
          </NavLink>
        </TableBodyCell>
        <TableBodyCell sx={{ width: '72px' }}>
          <IconButton onClick={dialogStateHandler}>
            <Icon id="delete" />
          </IconButton>
        </TableBodyCell>
      </TableRow>
      {isDialogShow ? (
        <RemoveCollection
          collectionId={id}
          collectionName={name}
          onClose={dialogStateHandler}
        />
      ) : null}
    </>
  );
};

export default CollectionsListItem;
